/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { UserStatus } from '@gh/builder-shared-data';
import { AbstractFinderGridDefinition } from '@gh/common-internal-shared';
import { TranslationService } from '@gh/core-mls';
import { ColDef } from 'ag-grid-community';
import { getUserFinderListItemId } from '../../';

@Injectable()
export class UserFinderGridDefinition extends AbstractFinderGridDefinition {
  getId = getUserFinderListItemId;

  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'userName',
      headerName: this.translationService.get('lbl_name'),
      width: 300,
    }, {
      field: 'status',
      headerName: this.translationService.get('lbl_status'),
      width: 300,
      cellClass: ({ data }: { data: any }) => ({
        [UserStatus.Active]: 'cell--positive',
        [UserStatus.Inactive]: 'cell--negative',
        [UserStatus.Deleted]: 'cell--negative',
      }[data.statusValue]),
    }];
  }
}
